<template>
  <div class="relative w-full flex items-center">
    <div
      v-if="prefix || $slots.prefix"
      class="flex items-center justify-center h-[36px] px-[16px] bg-[#F5F5F5] border-[1px] border-[#E5E5E5] border-r-0 rounded-l-[8px] text-[14px] text-[#0A0A0A] whitespace-nowrap shrink-0"
    >
      <slot name="prefix">
        {{ prefix }}
      </slot>
    </div>
    <div class="relative flex-1 flex items-center">
      <input
        :class="[
          'w-full h-[36px] px-[12px] border-[1px] text-[14px] text-[#0A0A0A] placeholder-[#A3A3A3] focus:outline-none focus:ring-[2px] focus:ring-[#E5E5E5] focus:ring-offset-[1px] transition-colors disabled:bg-[#F5F5F5] disabled:text-[#737373] disabled:cursor-not-allowed',
          (prefix || $slots.prefix) ? 'rounded-l-none' : 'rounded-l-[8px]',
          (suffix || $slots.suffix) ? 'rounded-r-none border-r-0' : 'rounded-r-[8px]',
          error ? 'border-[#EF4444] focus:border-[#EF4444] text-[#EF4444]' : 'border-[#E5E5E5] focus:border-primary'
        ]"
        :type="type"
        :value="value"
        :min="min"
        :max="max"
        :placeholder="placeholder"
        :disabled="disabled"
        :readonly="readonly"
        @input="handleInput"
      >
      <div
        v-if="(suffix || $slots.suffix) && !error"
        class="flex items-center justify-center h-[36px] min-w-[36px] px-[10px] border-[1px] border-[#E5E5E5] rounded-r-[8px] bg-white text-[#737373] shrink-0"
      >
        <slot name="suffix">
          {{ suffix }}
        </slot>
      </div>
      <div
        v-if="error"
        class="absolute inset-y-0 right-0 flex items-center pr-[12px] pointer-events-none"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="8"
            cy="8"
            r="7.5"
            stroke="#EF4444"
          />
          <path
            d="M8 4.5V8.5"
            stroke="#EF4444"
            stroke-linecap="round"
          />
          <path
            d="M8 11.5V11.05"
            stroke="#EF4444"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Input',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: '',
    },
    suffix: {
      type: String,
      default: '',
    },
    suffixBorder: {
      type: Boolean,
      default: true,
    },
    error: {
      type: Boolean,
      default: false,
    },
    min: {
      type: [String, Number],
      default: undefined,
    },
    max: {
      type: [String, Number],
      default: undefined,
    },
  },
  methods: {
    handleInput(event) {
      const { target } = event
      let val = target.value
      if (val !== '' && val != null && this.type === 'number') {
        const num = Number(val)
        if (!Number.isNaN(num)) {
          const max = this.max !== '' && this.max != null ? Number(this.max) : null
          const min = this.min !== '' && this.min != null ? Number(this.min) : null

          if (max !== null && max > 0 && num > max) val = max
          else if (min !== null && num < min) val = min

          if (val !== num) target.value = String(val)
        }
      }
      this.$emit('input', val)
    },
  },
}
</script>
